const carManagement = {
  bindingCar: "绑定车辆",
  noBindOBD: "请选择OBD设备号",
  speeding: "超速",
  sharpturn: "急转弯",
  emergencyBrake: "急刹车",
  rapidAcceleration: "急加速",
  timeOfAppointment: "预约时间",
  vehicleUser: "用车人",
  score: "总评分",
  mileage: "总里程",
  hour: "总耗时",
  bindingState: "绑定状态",
  brand: "品牌",
  model: "车型",
  maxSpeed: "车速阈值",
  dutystatus: "执勤状态",
  category: "车辆配置",
  area: "地区（府）",
  fuelType: "燃油类型",
  authorize:"授权",
  message: {
    needchange: "当前OBD已绑定其他车辆，是否更改绑定?",
    deleteBind: "已绑定的车辆不能删除",
    noPermission: "您无权操作该车辆信息"
  },
  Unbound: "未绑定",
  binding: "已绑定",
  untyTips: "是否解绑 ",
  createTime: "创建时间",
  notOBD: "该车辆未绑定OBD",
  bindsuccess: "绑定成功",
  untysuccess: "解绑成功",
  belong: "归属",
  personal: "私人",
  vinno: "车架号",
  transmitterNumber: "发动机号",
  series: "系列",
  boundHistory: "绑定历史记录",
  queryWidth: "185",
  successfulVerification: "验证成功",
  tableWidth: {
    licensePlate: "160",
    areaName: "140",
    brandName: "100",
    seriesName: "100",
    modelName: "100",
    barCode: "130",
    carTerminalStatus: "100",
    isPrivate: "100",
    realName: "140",
    cartype: "120",
    authorize: "150"
  },
  createAndUpdate: {
    title1: "车辆信息",
    title2: "车主信息",
    title3: "OBD设备信息",
    title4: "其他信息",
    permanent: "永久",
    temporary: "临时",
    create: "新增车辆",
    update: "编辑车辆",
    category: "车辆配置",
    vehicleowner: "车主",
    leftLabelWidth: "90px",
    rightLabelWidth: "100px",
    error: {
      area: "请选择车辆所在区域",
      category: "请选择车辆配置",
      owner: "请选择车主",
      licenseplate: "请输入车牌号码"
    },
    selectTerminal: {
      title: "双击选择OBD设备号",
      message: "该终端未绑定SIM卡",
      tabelWidth1: "60px",
      tabelWidth2: "75px"
    }
  },
  history: {
    title: "查看绑定历史"
  },
  details: {
    licenseMessage: "(红底表示临时牌照)"
  },
  tips: "解绑车辆",
  noComments: "请输入原因",
  errorComments: "备注长度在1-250以内",
  buttonLabelWidth: "100px",
  regVin: "Reg.VIN#",
  ecuVin: "ECU VIN#",
  ecuVinRefreshTime: "刷新时间",
  count: {
    total: "总车辆数",
    binding: "绑定车辆数",
    unbinding: "未绑定车辆数"
  },
  company: "企业",
  subCompany: "经销商",
  department: "门店",
  operate: {
    open: "开",
    close: "关",
    unlock: "解锁",
    atresia: "闭锁",
    pending: "升级中",
    width: '330px',
    tboxwidth: '390px',
    success: '命令下达成功',
    operateTip: "您确定要下达命令吗？",
    unlockTip: "您确定要解锁车辆",
    atresiaTip: "您确定要闭锁车辆",
    inputTip: "请输入您的密码",
  }
}
export default carManagement